import React from "react";
import Landing from "../pages/Landing";
import Login from "../pages/Login";
import LoginWithCode from "../pages/LoginWithCode";
import Signup from "../pages/Signup";
import SignupWithCode from "../pages/SignupWithCode";
import LoginWithLink from "../pages/LoginWithLink";
import LoginWithMicrosoft from "../pages/LoginWithMicrosoft";
import LoginWithGoogle from "../pages/LoginWithGoogle";
import LoginWithGithub from "../pages/LoginWithGithub";
import LoginWithApple from "../pages/LoginWithApple";
import LoginWithFacebook from "../pages/LoginWithFacebook";
import Logout from "../pages/Logout";
import { CloudPremisePluginRoute } from "@cloudpremise/portal_core";

const routes = ({history, page, basename}): CloudPremisePluginRoute[] => {
    return [
        {
            route: "/auth",
            component: (
                <Landing history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/login",
            component: (
                <Login history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/login-code",
            component: (
                <LoginWithCode history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/signup",
            component: (
                <Signup history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/signup-code",
            component: (
                <SignupWithCode history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/login-microsoft",
            component: (
                <LoginWithMicrosoft history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/login-link",
            component: (
                <LoginWithLink history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/logout",
            component: (
                <Logout history={history} basename={basename} page={page} />
            ),
            privacy: "private",
        },
        {
            route: "/auth/google",
            component: (
                <LoginWithGoogle history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/github",
            component: (
                <LoginWithGithub history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/apple",
            component: (
                <LoginWithApple history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
        {
            route: "/auth/facebook",
            component: (
                <LoginWithFacebook history={history} basename={basename} page={page} />
            ),
            privacy: "public",
        },
    ]
};

export default routes;